import { Injectable } from '@angular/core';
import { Profile } from '../../models/profile';

@Injectable({ providedIn: 'root' })
export class PhoneService {

  whatsAppLopes = '5511988952656';

  getDdiPlusPhone(ddiPhone: {ddi: string, phone: string}): string {
    const ddi = ddiPhone.ddi.replace('+', '');
    const phone = ddiPhone.phone.replace(/ /g, '').replace('-', '');
    return ddi + phone;
  }

  getAlternativePhone(profile: Profile): string {
    if (profile.alternative_phone) {
      return this.getDdiPlusPhone(profile.alternative_phone);
    }
  }

  getMainPhone(profile: Profile): string {
    if (profile.phone) {
      return this.getDdiPlusPhone(profile.phone);
    }
  }

  getCellphoneCheckingCountry(profile: Profile): string {
    const mainPhone = this.getMainPhone(profile);
    const alternativePhone = this.getAlternativePhone(profile);
    if (mainPhone?.startsWith('55') && mainPhone?.length === 13) {
      return mainPhone;
    } else if (alternativePhone?.startsWith('55') && alternativePhone?.length === 13) {
      return alternativePhone;
    } else if (mainPhone) {
      return mainPhone;
    } else if (alternativePhone) {
      return alternativePhone;
    } else {
      return this.whatsAppLopes;
    }
  }

}
